// 재고행의 포장값을 화면 표기로 바꾼다. (control-plane#13)
//
// 커스텀 릴은 벤더마다 이름이 다르다 — 디지키는 Digi-Reel®, 마우저·애로우도 각자 릴이 있다.
// 그런데 상세 화면은 "이 부품을 릴에 감아서 받는다" 는 같은 서비스를 파는 자리라
// 벤더와 무관하게 한 이름으로 보여준다.
//
// 상세에서 고른 이름과 장바구니·주문서에 뜨는 이름이 다르면 고객이 다른 물건으로 읽는다.
// 그래서 포장을 그리는 자리는 전부 이 함수를 거친다.
//
// 벤더를 넓힐 때는 아래 목록에 그 벤더의 커스텀 릴 포장값을 추가하면 된다.
// ⚠️ 풀릴(digikey 'Tape & Reel (TR)', mouser 'Reel', onechip '개별 (풀 릴로 제공)')은
//    제조사 완제품이라 여기 넣으면 안 된다. 커스텀 릴과 다른 물건이다.
export const CUSTOM_REEL_LABEL = "Custom Reel";

const CUSTOM_REEL_PACKAGINGS = ["Digi-Reel®"];

export const packagingLabel = (value) => {
  if (value == null) return value;
  return CUSTOM_REEL_PACKAGINGS.indexOf(String(value).trim()) !== -1
    ? CUSTOM_REEL_LABEL
    : value;
};
